import { AbsoluteCenter, Spinner } from '@chakra-ui/react';

const SpinnerLoading = () => (
  <AbsoluteCenter>
    <Spinner />
  </AbsoluteCenter>
);

export default SpinnerLoading;
